import React, { useState } from "react";
import { RiCloseFill } from "react-icons/ri";
import { cn } from "~/utils/fontsConfig";
import { BASE_INPUT_STYLES } from "./v3/themed/BASE_STYLE_DEFINITIONS";

export const TagInput = ({
    tags,
    onAddTag,
    onRemoveTag,
    disabled = false,
    className,
}: {
    tags: string[];
    onAddTag: (newTags: string[]) => void;
    onRemoveTag: (tag: string) => void;
    disabled?: boolean;
    className?: string;
}) => {
    const [newTag, setNewTag] = useState("");

    const handleAddTag = () => {
        const sanitizedTag = newTag.trim();
        if (sanitizedTag === "" || tags.includes(sanitizedTag)) return;
        onAddTag([sanitizedTag]);
        setNewTag("");
    };

    const handleChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newInputs = e.target.value
            .split(/,/)
            .filter((v) => v.trim() !== "");

        if (newInputs.length === 0) {
            setNewTag(e.target.value);
            return;
        }

        if (newInputs.length === 1) {
            const value = e.target.value;
            const lastChar = value.slice(-1);
            if (lastChar !== ",") {
                setNewTag(value);
            } else {
                onAddTag(newInputs);
                setNewTag("");
            }
        } else {
            onAddTag(newInputs);
            setNewTag("");
        }
    };

    return (
        <div
            className={cn(
                BASE_INPUT_STYLES,
                "flex flex-wrap gap-2 p-2",
                disabled && "cursor-not-allowed opacity-50",
            )}
        >
            {tags.map((tag) => (
                <div
                    key={tag}
                    className="flex items-center rounded-lg bg-v3-N-400 px-2 py-1 text-sm"
                >
                    <span>{tag}</span>
                    <button
                        onClick={() => onRemoveTag(tag)}
                        className={cn(
                            "ml-1 p-1 hover:text-v3-N-100",
                            disabled && "hidden",
                        )}
                        aria-label={`Remove tag ${tag}`}
                    >
                        <RiCloseFill />
                    </button>
                </div>
            ))}
            <input
                disabled={disabled}
                placeholder="Add tag..."
                value={newTag}
                onChange={handleChangeInput}
                className={cn(
                    "min-w-[100px] flex-grow border-none bg-transparent focus:outline-none focus:ring-0",
                    disabled && "cursor-not-allowed opacity-50",
                    className,
                )}
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        e.preventDefault();
                        handleAddTag();
                    }
                }}
            />
        </div>
    );
};
